import { companyPhone } from "~/common/config/companyContact";
import clsx from "clsx";

import { useTranslation } from "~/app/hooks/useTranslation";
import EmailIconSvg from "~/assets/images/keepInTouch/email.svg";
import PhoneIconSvg from "~/assets/images/keepInTouch/phone.svg";

import styles from "./KeepInTouchSection1.module.scss";

const KeepInTouchSection1 = () => {
  const { t } = useTranslation();
  return (
    <div className={clsx(styles.section, "card")}>
      <h1 className="pal-section-title" title={t("keepInTouch.section1.title")}>{t("keepInTouch.section1.title")}</h1>
      <p>{t("keepInTouch.section1.description")}</p>
      <h2>{t("keepInTouch.section1.talkWithOurTeam")}</h2>
      <div className={styles.buttonContainer}>
        <a href={companyPhone.href}>
          <PhoneIconSvg />
          {companyPhone.display}
        </a>
        <a href={`mailto:${t("keepInTouch.section1.emailAddress")}`}>
          <EmailIconSvg />
          {t("keepInTouch.section1.emailAddress")}
        </a>
      </div>
    </div>
  );
};

export default KeepInTouchSection1;
